import * as React from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormGroup from "@mui/material/FormGroup";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import InputAdornment from "@mui/material/InputAdornment";
import InfoIcon from "@mui/icons-material/Info";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import arrondir from "../libs/arrondir.js";

function ReglageParametres({
  ageDepart,
  baseAgeDepart,
  handleAgeDepart,
  niveauCotisationUtilisateur,
  baseNiveauCotisation,
  handleNiveauCotisationUtilisateur,
  pensionMoyenne,
  basePensionMoyenne,
  handlePensionMoyenne,
  step,
}) {
  const descriptionAgeDepart =
    "62 ans est l'actuel âge de départ légal, c'est-à-dire l'âge minimum auquel un retraité peut partir pour espérer pouvoir toucher le taux plein de sa retraite. En réalité, le simulateur prend en compte l'âge effectif moyen de départ, qui est plus tard que cet âge légal (autour de 63,9 ans en 2070 selon les projections du COR). Un décalage de votre part de l'âge de départ légal va modifier d'autant l'âge effectif moyen projeté par le COR.";

  const descriptionCotisation =
    "Le taux de cotisation correspond à la part du salaire brut qui est affecté, d'une quelconque manière, au financement des retraites. Il est autour de " +
    baseNiveauCotisation +
    "% aujourd'hui. Une modification de votre part sera lissée pour atteindre son plein effet en 2030.";
  const descriptionPensionMoyenne =
    "C'est la moyenne des pensions brutes versées au retraités, en euro constant de 2022, c'est-à-dire sans prendre en compte l'inflation au fil des années. Elle est autour de " +
    basePensionMoyenne +
    "€ en 2022";

  return (
    <FormGroup>
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        {step !== 1 ? (
          <>
            <Grid item xs={5} sm={5}>
              <Typography
                textAlign="right"
                color={ageDepart != baseAgeDepart ? "primary" : ""}
                fontWeight={ageDepart != baseAgeDepart ? "bold" : ""}
              >
                Âge de départ légal{" "}
                <Tooltip
                  title={descriptionAgeDepart}
                  leaveTouchDelay={3000}
                  enterTouchDelay={50}
                >
                  <InfoIcon fontSize="small" color="info" />
                </Tooltip>{" "}
                :
              </Typography>
            </Grid>
            <Grid item xs={5} sm={5}>
              <TextField
                label="Age de départ"
                id="ageDepart"
                type="number"
                value={ageDepart}
                onChange={handleAgeDepart}
                sx={{ m: 1, minWidth: "12ch" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">ans</InputAdornment>
                  ),
                }}
                variant="filled"
              />
            </Grid>
            <Grid item xs={2} sm={2}>
              <Typography color="primary" fontWeight="bold">
                {ageDepart > baseAgeDepart ? <ArrowUpwardIcon /> : ""}{" "}
                {ageDepart < baseAgeDepart ? <ArrowDownwardIcon /> : ""}
                {ageDepart != baseAgeDepart
                  ? ageDepart -
                    baseAgeDepart +
                    " an" +
                    (Math.abs(ageDepart - baseAgeDepart) > 1 ? "s" : "")
                  : " "}
              </Typography>
            </Grid>{" "}
          </>
        ) : null}
        <Grid item xs={5} sm={5}>
          <Typography
            textAlign="right"
            color={
              niveauCotisationUtilisateur != baseNiveauCotisation
                ? "primary"
                : ""
            }
            fontWeight={
              niveauCotisationUtilisateur != baseNiveauCotisation ? "bold" : ""
            }
          >
            Taux de cotisation{" "}
            <Tooltip
              title={descriptionCotisation}
              leaveTouchDelay={3000}
              enterTouchDelay={50}
            >
              <InfoIcon fontSize="small" color="info" />
            </Tooltip>{" "}
            :
          </Typography>
        </Grid>
        <Grid item xs={5} sm={5}>
          <TextField
            label="Taux de cotisation"
            id="tauxCotisation"
            type="number"
            value={niveauCotisationUtilisateur}
            onChange={handleNiveauCotisationUtilisateur}
            sx={{ m: 1, minWidth: "12ch" }}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            variant="filled"
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography color="primary" fontWeight="bold">
            {niveauCotisationUtilisateur > baseNiveauCotisation ? (
              <ArrowUpwardIcon />
            ) : (
              ""
            )}{" "}
            {niveauCotisationUtilisateur < baseNiveauCotisation ? (
              <ArrowDownwardIcon />
            ) : (
              ""
            )}
            {niveauCotisationUtilisateur != baseNiveauCotisation
              ? arrondir(
                  niveauCotisationUtilisateur - baseNiveauCotisation,
                  1
                ) +
                " pt" +
                (Math.abs(niveauCotisationUtilisateur - baseNiveauCotisation) >
                1
                  ? "s"
                  : "")
              : " "}
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography
            textAlign="right"
            color={pensionMoyenne != basePensionMoyenne ? "primary" : ""}
            fontWeight={pensionMoyenne != basePensionMoyenne ? "bold" : ""}
          >
            Pension moyenne{" "}
            <Tooltip
              title={descriptionPensionMoyenne}
              leaveTouchDelay={3000}
              enterTouchDelay={50}
            >
              <InfoIcon fontSize="small" color="info" />
            </Tooltip>{" "}
            :
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <TextField
            label="Pension moyenne"
            id="pensionMoyenne"
            type="number"
            value={pensionMoyenne}
            onChange={handlePensionMoyenne}
            sx={{ m: 1, minWidth: "12ch" }}
            InputProps={{
              endAdornment: <InputAdornment position="end">€</InputAdornment>,
            }}
            variant="filled"
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography color="primary" fontWeight="bold">
            {pensionMoyenne > basePensionMoyenne ? <ArrowUpwardIcon /> : ""}{" "}
            {pensionMoyenne < basePensionMoyenne ? <ArrowDownwardIcon /> : ""}
            {pensionMoyenne != basePensionMoyenne
              ? Math.round(
                  ((pensionMoyenne - basePensionMoyenne) / basePensionMoyenne) *
                    1000
                ) /
                  10 +
                " %"
              : " "}
          </Typography>
        </Grid>
      </Grid>
    </FormGroup>
  );
}

export default ReglageParametres;
